import CustomizedSnackbars from "./components/SnackbarComponent";
import MainRouter from "./MainRouter/MainRouter";
import { useSelector } from 'react-redux';





const App = () => {
  const state = useSelector(state=>state)
  const SnackBarState = state.globalreducer.snackBar


  return(
    <div>
      <MainRouter />
      <CustomizedSnackbars open={SnackBarState.open} message={SnackBarState.message} severity={SnackBarState.severity} />
    </div>
  )
}
export default App;
